import { faUser as fasUser } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { validFirstName, validLastName } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm.fn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormCheck, FormEmail, FormInput } from "bm-ui-kit";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { renderText } from "../domain";

interface Props extends AbstractStepProps {
	eligibleForWorkerLoan: boolean;
}

export class SubscriptionForm extends AbstractStep<{}, Props> {
	protected renderContent(): ReactNode {
		const { eligibleForWorkerLoan } = this.props;
		const { eligible, details } = renderText(eligibleForWorkerLoan);

		return (
			<>
				<Card.Header className="text-white text-center bg-green-rounded">
					<Card.Title className="h2">
						A megadott adatok alapján <span className="text-gold">{eligible}</span> a munkáshitelre
					</Card.Title>
				</Card.Header>
				<Card.Body className="py-2">
					<p className="h4">A részleteket elküldjük e-mailben:</p>
					<p className="h3 mt-3 fw-normal text-center">{details}</p>
					<Row className="mt-5">
						<Col className="pr-1" xs={6}>
							<FormInput
								placeholder="Vezetéknév"
								name="lastName"
								prepend={<FontAwesomeIcon icon={fasUser} />}
								validate={validLastName}
								required
							/>
						</Col>
						<Col className="pl-1" xs={6}>
							<FormInput
								placeholder="Keresztnév"
								name="firstName"
								prepend={<FontAwesomeIcon icon={fasUser} />}
								validate={validFirstName}
								required
							/>
						</Col>
					</Row>
					<FormEmail placeholder="E-mail cím" name="email" required />
					<FormCheck
						className="mb-1 font-weight-bold text-white"
						label="Szeretnék hírlevelet kapni az újdonságokról, kiemelt banki ajánlatokról."
						name="wantsNewsletter"
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" variant="gold">
						Feliratkozom!
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getClassName(): string {
		return compact([super.getClassName(), "bg-success"]).join(" ");
	}

	protected getComponentName(): string {
		return "SubscriptionForm";
	}
}
